import React, { PropTypes } from 'react';
import SelectItemModal from 'template/Modals/SelectItem';

export default function(opts) {
  let filterOptions = [
      {'name': __('Waiting List', 'registrationTable'), 'value': '0'},
      {'name': __('Success', 'registrationTable'), 'value': '2'},
      {'name': __('Transferred', 'registrationTable'), 'value': '4'}
    ]
  // this will return a promise
  return SelectItemModal({
    headerTitle: __('Select Status', 'teacherAttendance'),
    headerIcon: 'fa icon-ok',
    itemName: __('Status', 'teacherAttendance'),
    searchPlaceholder: __('Registration Status', 'registrationTable'),
    hideSearchbar: true,
    fetchItems: (cb)=>{
      cb(filterOptions)
    },

    components: {
      SelectItem: ({item, getItemLabel, selected, onClickSelect, selectText, selectedText, mixin}) => {

        return (
          <div className='select-item' >
            <div>
              { item.name }
            </div>
            <div className='select-button'>
              { selected && <span className='btn-link currently-selected' onClick={onClickSelect}>{selectText || __('Selected', 'SelectItemModal')}</span>}
              { !selected && <span className='btn-link' onClick={onClickSelect}>{selectedText || __('Select', 'SelectItemModal')}</span>}
            </div>
          </div>
         );
      }
    },
    selectFilter: (item, alreadySelected, selected)=>{
      return alreadySelected.value == item.value;
    },

    selected: opts.selected,

    ...opts,

  })
}



// WEBPACK FOOTER //
// ./src/template/Modals/PosterRegistrationStatus/index.js